export const PRIMARY_COLOR = '#6e63fa' // Purple
export const OLD_PRIMARY_COLOR_LIGHT = '#A9A1FD' // Light purple, for reference
export const PRIMARY_COLOR_LIGHT = '#EBEAFF' // lighter purple
export const SUCCESS_COLOR = '#12B76A' // Green
export const SECONDARY_COLOR = '#00c2a1' // Dark green
export const TEXT_COLOR = '#101828' // Dark grey
export const BACKGROUND_COLOR = '#F9FAFB' // Grey 50
export const ERROR_COLOR = '#F04438' // Red (Match Semantic UI error color)
export const DISABLED_COLOR = '#9f9b9b' // Light grey
export const OUTLINE_GREY = '#D0D5DD' // Light grey
export const LIGHT_SECONDARY_COLOR = '#EBFBFF' // Light blue
